import styled from 'styled-components';

export const List = styled.ul`
  min-width: 210px;
  border: 1px solid #f4f4f4;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  margin-left: auto;
  margin-top: -10px;
  list-style-type: none;
  li {
    list-style-type: none;
  }
`;
export const ListItem = styled.li`
  padding: 16px 12px;
  font-size: 12px;
  color: #000000;
  cursor: pointer;
  border-bottom: 1px #d7e6f1 solid;
  :last-child {
    border-bottom: 0;
  }
  ${props =>
      props.selected &&
      `
        font-weight: 700;
    `}
    :hover {
    background-color: #f1f9ff;
    font-weight: 700;
  }
`;
